import { db } from "@/db/db";
import { QSO } from "@/types/qso.types";

export class QSORepository {
  async findAll(): Promise<QSO[]> {
    return await db.qsos.toArray();
  }

  async findById(id: string): Promise<QSO | undefined> {
    return await db.qsos.get(id);
  }

  async findByCall(call: string): Promise<QSO[]> {
    return await db.qsos.where("call").equals(call).toArray();
  }

  async create(qso: Omit<QSO, "id">): Promise<QSO> {
    const newQSO: QSO = {
      id: this.generateId(),
      ...qso,
    };
    await db.qsos.add(newQSO);
    return newQSO;
  }

  async update(id: string, updates: Partial<QSO>): Promise<void> {
    await db.qsos.update(id, updates);
  }

  async delete(id: string): Promise<void> {
    await db.qsos.delete(id);
  }

  async deleteAll(): Promise<void> {
    await db.qsos.clear();
  }

  async bulkCreate(qsos: (Omit<QSO, "id"> | QSO)[]): Promise<void> {
    const newQSOs: QSO[] = qsos.map((qso) => ({
      id: 'id' in qso ? qso.id : this.generateId(),
      ...qso,
    }));
    
    await db.qsos.bulkPut(newQSOs);
  }

  private generateId(): string {
    return `qso_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
}

export const qsoRepository = new QSORepository();
